export const appLoaderStyles = {
  backdrop: { background: "white" },
};
